import script from "./EditDentalIpdBill.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDentalIpdBill.vue?vue&type=script&setup=true&lang=js"

import "./EditDentalIpdBill.vue?vue&type=style&index=0&id=992fd9c4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-992fd9c4"]])

export default __exports__